import type { ReactNode } from 'react';
import React from 'react';
import combineStyles from '../utils/combineStyles';
import { useAppSelector } from '../app/hooks';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';

/**
 * # DateTimeSelectorsWrapper
 * This is a wrapper that is meant to wrap these primitive components for consistency
 * - DateSelector
 * - TimeSelector
 *
 * The reason why we do this rather than creating a component called DateTimeSelector
 * where it includes these above components because we want to decouple and avoid
 * passing props too many times.
 *
 * ! Please do not put any logic in here, this is just a simple wrapper.
 *
 * @param style - Additional styles; maybe you want to make it slightly different but
 * only for catering
 */
const DateTimeSelectorsWrapper = ({
  children,
  style,
}: {
  children: ReactNode;
  style?: React.CSSProperties;
}) => {
  const isMobile = useAppSelector(getDeviceTypeMobile);

  return (
    <div
      style={combineStyles(
        styles.dateTimeSelectorsWrapper,
        isMobile && styles.dateTimeSelectorsWrapperMobile,
        style,
      )}
    >
      {children}
    </div>
  );
};

export default DateTimeSelectorsWrapper;

const styles: Styles = {
  dateTimeSelectorsWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    flexWrap: 'wrap',
    padding: '0 20px',
    rowGap: 20,
    marginTop: 25,
    marginBottom: 20,
  },

  dateTimeSelectorsWrapperMobile: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    columnGap: 20,
    marginTop: 12,
    marginBottom: 20,
  },
};
